import React from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import courseRepository  from '../../services/courses';
import formInitialiser   from '../../services/formInitialiser';
import FormSubmitter     from '../../services/formSubmitter';

import * as courseListActions   from '../../actions/courseList';
import * as presenterActions    from '../../actions/presenterList';
import * as resourcePackActions from '../../actions/resourcePackList';

import Button               from '../Button';
import Input                from '../Input';
import InlineError          from '../InlineError';
import HtmlEditor           from '../HtmlEditor';
import SelectBox            from '../SelectBox';
import InputGroup           from '../InputGroup';
import InputSection         from '../InputSection';
import Label                from '../Label';
import TimetableSelect      from '../TimetableSelect';
import PriceInputs          from '../PriceInputs';
import Checkbox             from '../Checkbox';
import PriceInput           from "../PriceInput";
import FontIcon             from "../FontIcon";

import Typeahead            from "pattern-library/dist/js/components/Typeahead";
import TypeaheadResult      from "pattern-library/dist/js/components/TypeaheadResult";

class CourseForm extends React.Component {
    constructor(){
        super();

        this.state = {
            presenterSearch: "",
            packSearch: "",
            assignedPresenters: []
        }
    }

    componentDidMount() {
        if (this.props.isELearningCourse) {
            this.props.fields.type.onChange('online');
        }

        if (this.props.mode === 'edit') {

            const { courseToEdit } = this.props;

            this.props.fields.elearning_course_id.onChange(courseToEdit.elearning_course_id);
            this.props.fields.override_price.onChange(!!courseToEdit.overridden_price);

            courseToEdit.sorted_elearning_units.forEach((unit) => this.props.fields.units.addField({
                ...unit,
                name: unit.title,
                description_html: unit.description
            }));
        }


    }

    _formatCourse(course) {
        return {
            ...course,
            timetable_id: course.timetable_id || null
        };
    }

    _getCreateCourseMethod(course) {

        if (this.props.isELearningCourse) {
            return courseRepository.createELearning(course);
        }

        return courseRepository.create(this._formatCourse(course));
    }

    _getUpdateCourseMethod(course) {

        if (this.props.isELearningCourse) {
            return courseRepository.updateELearning(course);
        }

        return courseRepository.update(this._formatCourse(course));
    }

    _presenterChecked(presenter, presentersField) {

        presentersField.addField(presenter);
    }

    _presenterUnchecked(fieldIndex, presentersField) {

        presentersField.removeField(fieldIndex);
    }

    _resourcePackChecked(resourcePack, resourcePacksField) {

        resourcePacksField.addField(resourcePack);
    }

    _resourcePackUnchecked(fieldIndex, resourcePacksField) {

        resourcePacksField.removeField(fieldIndex);
    }

    _setELearningCPD(course) {
        if(course.credits_to_be_awarded !== ''){
            let new_cpd = course.credits_to_be_awarded.replace('CPD:','');
            new_cpd = new_cpd.split('.');
            this.props.fields.cpd_hours.onChange(new_cpd[0]);
            this.props.fields.cpd_minutes.onChange(new_cpd[1]);
        } else {
            this.props.fields.cpd_hours.onChange('');
            this.props.fields.cpd_minutes.onChange('');
        }
    }

    _onElearningCourseSelected(evt) {

        if (evt.target.value !== '') {

            this._importLearnuponCourse(evt.target.value);

        } else {

            this.props.initializeForm({
                ...this.props.values,
                description: '',
                name: '',
                cpd_hours: '',
                cpd_minutes: '',
                elearning_course_id: null,
                units: []
            });
        }
    }

    _syncWithLearnupon() {
        const {elearning_course_id} = this.props.values;
        if (elearning_course_id) {
            this._importLearnuponCourse(elearning_course_id);
        }
    }

    _importLearnuponCourse(learnuponCourseId) {

        this.props.initializeForm({...this.props.values, units: []});

        const eLearningCourseSelected = this.props.eLearningCourses.find(course => course.id == learnuponCourseId);
        this.props.fields.name.onChange(eLearningCourseSelected.name);
        this.props.fields.description.onChange(eLearningCourseSelected.description_html);
        this._setELearningCPD(eLearningCourseSelected);
        this.props.fields.elearning_course_id.onChange(learnuponCourseId);
        this.props.fields.timetable_id.onChange(null);
        eLearningCourseSelected.units.forEach((unit) => this.props.fields.units.addField({ ...unit, elearning_course_id: unit.id }));
    }

    _resetOverriddenPrice(e) {
        if (e.target.checked) {
            this.props.fields.overridden_price.onChange('0.00');
        } else {
            this.props.fields.overridden_price.onChange(null);
        }
        this.props.fields.override_price.onChange(e.target.checked);
    }

    _handleSearch(searchTerm){
        this.setState({
            ...this.state,
            presenterSearch: searchTerm
        });
        this.props.getPresenters(searchTerm);
    }

    _handlePackSearch(searchTerm){
        this.setState({
            ...this.state,
            packSearch: searchTerm
        });
        this.props.getPacks(searchTerm);
    }

    render() {

        const {
            fields: {
                reference_code,
                name,
                description,
                cpd_hours,
                cpd_minutes,
                module_id,
                timetable_id,
                elearning_course_id,
                private_price,
                public_price,
                presenters,
                resource_packs,
                promotional_details,
                resource_code,
                type,
                units,
                override_price,
                overridden_price,
                allow_multi_delegate_discount
            },
            handleSubmit,
            submitting
        } = this.props;

        const submitSuccess = this.props.isELearningCourse ? this.props.submitSuccessELearning : this.props.submitSuccess;
        
        var formSubmitter = new FormSubmitter({
            create: this._getCreateCourseMethod.bind(this),
            update: this._getUpdateCourseMethod.bind(this),
            submitSuccess: submitSuccess
        });

        const assignedPresenters = this.props.presenters.filter(presenter => {
            return this.props.fields.presenters.find(presenterFind => {
                return presenterFind.id.value === presenter.id;
            });
        });

        const assignedResourcePacks = this.props.resourcePacks.filter(pack => {
            return this.props.fields.resource_packs.find(packFind => {
                return packFind.id.value === pack.id;
            });
        });

        return (

            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.mode)) }>

                <InputSection>

                    {this.props.isELearningCourse && (
                        <div>
                            <InputGroup>

                                <Label isRequired="true">Reference Code</Label>

                                <Input { ...reference_code } errors={ reference_code.error } />

                                <InlineError errors={ reference_code.error } />

                            </InputGroup>


                            <InputGroup>
                                <Label isRequired={ true }>LearnUpOn Course</Label>

                                <SelectBox {...elearning_course_id} name={elearning_course_id.name} onChange={this._onElearningCourseSelected.bind(this)} errors={ elearning_course_id.error }>
                                    <option value=''>
                                        Select LearnUpon Course
                                    </option>
                                    {
                                        this.props.eLearningCourses.map((course) => {

                                            return (
                                                <option key={ course.id } value={ course.id }>
                                                    { course.name }
                                                </option>
                                            )
                                        })
                                    }

                                </SelectBox>

                                <InlineError errors={ elearning_course_id.error } />

                            </InputGroup>
                        </div>
                    )}

                    <InputGroup>
                        <Label isRequired={ true }>Name</Label>
                        <Input { ...name } errors={ name.error } />
                        <InlineError errors={ name.error } />
                    </InputGroup>

                    {!this.props.isELearningCourse &&
                        <InputGroup>
                            <Label isRequired={ true }>Type</Label>

                            <SelectBox { ...type } errors={ type.error }>
                                <option value="classroom">
                                    Classroom
                                </option>
                                <option value="conference">
                                    Conference
                                </option>
                                <option value="webinar">
                                    Webinar
                                </option>
                            </SelectBox>

                            <InlineError errors={ type.error } />
                        </InputGroup>
                    }

                    <InputGroup>
                        <Label isRequired={ true }>Category</Label>

                        <SelectBox { ...module_id } errors={ module_id.error }>

                            {
                                this.props.modules.map((module) => {

                                    return (
                                        <option key={ module.id } value={ module.id }>
                                            { module.name }
                                        </option>
                                    )
                                })
                            }

                        </SelectBox>

                        <InlineError errors={ module_id.error } />

                    </InputGroup>

                    {!this.props.isELearningCourse && (<InputGroup>

                        <TimetableSelect
                            timetableId={ timetable_id }
                            timetables={ this.props.timetables }
                        />

                    </InputGroup>)}

                    {!override_price.value &&
                    <InputGroup>
                        <PriceInputs privatePrice={ private_price } publicPrice={ public_price } />
                    </InputGroup>
                    }

                    {override_price.value &&
                    <InputGroup>
                        <Label isRequired="true">Delegate Price</Label>
                        <PriceInput className={ style['price-input'] } { ...overridden_price } errors={ overridden_price.error } />
                        <InlineError errors={ overridden_price.error } />
                    </InputGroup>
                    }

                    <InputGroup>
                        <Label>
                            <Checkbox { ...override_price} onChange={this._resetOverriddenPrice.bind(this)} />
                            Use Fixed Price Per Delegate
                        </Label>
                        <InlineError errors={ override_price.error } />
                    </InputGroup>

                    <div className={style['form-group-container']}>
                        {this.props.isELearningCourse && (
                            <InputGroup className={ style['access-code-container'] }>

                                <Label>Resource Access Code</Label>

                                <Input { ...resource_code } errors={ resource_code.error } className={ style['access-code-input'] } />

                                <InlineError errors={ resource_code.error } />

                            </InputGroup>
                        )}

                        <InputGroup className={ style['cpd-container'] }>
                            <Label isRequired={ true }>CPD Time</Label>

                            <div>
                                <div styleName="cpd-time-group">
                                    <Input styleName="cpd-time-input" { ...cpd_hours } errors={ cpd_hours.error } disabled={this.props.isELearningCourse} />
                                    <span styleName="cpd-time-unit">hours</span>
                                    <InlineError errors={ cpd_hours.error } />
                                </div>

                                <div styleName="cpd-time-group">
                                    <Input styleName="cpd-time-input" { ...cpd_minutes } errors={ cpd_minutes.error } disabled={this.props.isELearningCourse} />
                                    <span styleName="cpd-time-unit">minutes</span>
                                    <InlineError errors={ cpd_minutes.error } />
                                </div>
                            </div>

                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>
                            <Checkbox { ...allow_multi_delegate_discount} />
                            Allow multi delegate discount (10%)
                        </Label>
                        <InlineError errors={ allow_multi_delegate_discount.error } />
                    </InputGroup>

                    <div styleName="form-group-container">

                        <InputGroup>
                            <Typeahead
                                label=""
                                placeholder="Add Presenter..."
                                value={this.state.presenterSearch}
                                onChange={t => this._handleSearch(t)}
                                onSelectResult={selected => this._presenterChecked(selected, presenters)}
                            >
                                {this.props.presenterSearchResults && this.props.presenterSearchResults.map(r => {
                                    return (
                                        <TypeaheadResult
                                            key={r.id}
                                            value={r}
                                        >
                                            {r.name}
                                        </TypeaheadResult>
                                    )
                                })}
                            </Typeahead>

                            {assignedPresenters.map((presenter, index) => (
                                <span className={style['typeahead-presenter']} key={index}>
                                    <span onClick={presenter => this._presenterUnchecked(presenter.id, presenters)}>
                                        <FontIcon className={style['remove-speaker']} iconName="close" />
                                    </span> {presenter.name}
                                </span>
                            ))}
                        </InputGroup>

                        <InputGroup>
                            <Typeahead
                                label=""
                                placeholder="Add Resource Pack..."
                                value={this.state.packSearch}
                                onChange={t => this._handlePackSearch(t)}
                                onSelectResult={selected => this._resourcePackChecked(selected, resource_packs)}
                            >
                                {this.props.resourcePackSearchResults && this.props.resourcePackSearchResults.map(r => {
                                    return (
                                        <TypeaheadResult
                                            key={r.id}
                                            value={r}
                                        >
                                            {r.name}
                                        </TypeaheadResult>
                                    )
                                })}
                            </Typeahead>

                            {assignedResourcePacks.map((pack, index) => (
                                <span className={style['typeahead-presenter']} key={index}>
                                    <span onClick={pack => this._resourcePackUnchecked(pack.id, resource_packs)}>
                                        <FontIcon className={style['remove-speaker']} iconName="close" />
                                    </span> {pack.name}
                                </span>
                            ))}
                        </InputGroup>

                    </div>

                    {this.props.isELearningCourse &&
                        <InputGroup>
                            <Button
                                type="button"
                                disabled={this.props.isRefreshingCourse}
                                onClick={this._syncWithLearnupon.bind(this)}>
                                Re-sync with LearnUpon
                            </Button>
                        </InputGroup>
                    }

                    <InputGroup>

                        <Label>Course Overview</Label>

                        <HtmlEditor { ...description }
                                    errors={ description.error }
                                    contentsClassName={ style['course-description-editor'] }>
                        </HtmlEditor>

                        <InlineError errors={ description.error } />

                    </InputGroup>

                </InputSection>

                {!this.props.isELearningCourse && (<InputSection>

                    <InputGroup>
                        <Label>Additional Cost Information</Label>
                        <HtmlEditor { ...promotional_details }
                                    errors={ promotional_details.error }
                                    contentsClassName={ style['course-promotions-editor'] }>
                        </HtmlEditor>
                    </InputGroup>

                </InputSection>)}

                {this.props.isELearningCourse && units.length > 0 &&

                    <div>

                        {units.map(unit => {

                            return (
                                <fieldset className={style['module-container']}>
                                    <legend>Module</legend>

                                    <InputSection key={unit.id.value}>

                                        <InputGroup>
                                            <Label>Title</Label>
                                            <Input { ...unit.name } errors={unit.name.error} />
                                            <InlineError errors={ unit.name.error } />
                                        </InputGroup>

                                        <InputGroup className={ style['cpd-container'] }>
                                            <Label isRequired={ true }>CPD Time</Label>

                                            <div>
                                                <div styleName="cpd-time-group">
                                                    <Input styleName="cpd-time-input" { ...unit.cpd_hours } errors={ unit.cpd_hours.error } disabled={this.props.isELearningCourse} />
                                                    <span styleName="cpd-time-unit">hours</span>
                                                    <InlineError errors={ unit.cpd_hours.error } />
                                                </div>

                                                <div styleName="cpd-time-group">
                                                    <Input styleName="cpd-time-input" { ...unit.cpd_minutes } errors={ unit.cpd_minutes.error } disabled={this.props.isELearningCourse} />
                                                    <span styleName="cpd-time-unit">minutes</span>
                                                    <InlineError errors={ unit.cpd_minutes.error } />
                                                </div>
                                            </div>

                                        </InputGroup>

                                        <InputGroup>
                                            <Label>Description</Label>
                                            <HtmlEditor { ...unit.description_html }
                                                        errors={ unit.description_html.error }
                                                        contentsClassName={ style['course-promotions-editor'] }>
                                            </HtmlEditor>
                                        </InputGroup>

                                    </InputSection>
                                </fieldset>
                            );
                        })}
                    </div>
                }

                <Button disabled={ submitting }
                        autoWidth="true"
                        type="submit"
                        theme="success">

                    <span>Save</span>

                </Button>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'course',
    fields: [
        'id',
        'reference_code',
        'name',
        'description',
        'cpd_hours',
        'cpd_minutes',
        'module_id',
        'timetable_id',
        'elearning_course_id',
        'private_price',
        'public_price',
        'presenters[].id',
        'resource_packs[].id',
        'promotional_details',
        'resource_code',
        'type',
        'units[].id',
        'units[].name',
        'units[].description_html',
        'units[].cpd_hours',
        'units[].cpd_minutes',
        'units[].elearning_course_id',
        'units[].type',
        'override_price',
        'overridden_price',
        'allow_multi_delegate_discount'
    ]
};

function mapStateToProps(state) {

    const { courseFormMode, defaultCourseForm, courseToEdit, isRefreshingCourses } = state.courseList;

    return {
        isRefreshingCourse: isRefreshingCourses,
        initialValues: formInitialiser.getInitialValues(courseFormMode, defaultCourseForm, courseToEdit),
        mode: courseFormMode,
        courseToEdit,
        presenterSearchResults: state.presenterList.searchResults,
        resourcePackSearchResults: state.resourcePackList.searchResults,
    };
}

function mapDispatchToProps(dispatch) {

    return {
        submitSuccess: () => {

            dispatch(courseListActions.hideCourseOverlay());
            dispatch(courseListActions.refreshCourses());
        },
        submitSuccessELearning: () => {

            dispatch(courseListActions.hideCourseOverlay());
            dispatch(courseListActions.getELearning());
        },
        getPresenters: searchTerm => {

            dispatch(presenterActions.searchPresenters(searchTerm));
        },
        getPacks: searchTerm => {

            dispatch(resourcePackActions.searchPacks(searchTerm));
        }
    };
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(CourseForm, style));


// WEBPACK FOOTER //
// ./components/CourseForm/index.js